import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';

import tt from'../../../pip/library/pi-tt/pi-tt.js';

declare global {
  interface Window {
    ['HIP']: any;
    ga: any;
  }
}

export interface IAnalyticsModuleConfiguration extends IModuleConfiguration {
  trackingId: string;
}

export class AnalyticsModule extends ModuleConfiguration {
  configuration: IAnalyticsModuleConfiguration;
  private __onHashChange__windowBound: (e: Event) => void;
  ga: any;

  /**
   *
   * @param configuration
   */
  initialize(configuration: IAnalyticsModuleConfiguration) {
    return new Promise((resolve, reject) => {
      this.configuration = this.__defaultConfiguration(configuration);

      if (this.configuration.trackingId === '') {
        reject('no tracking id');
      }
      const analyticsScriptEl = document.createElement('script');

      analyticsScriptEl.async = true;
      analyticsScriptEl.src = 'https://www.google-analytics.com/analytics.js';
      analyticsScriptEl.onload = () => this.__runAnalyticsCommands();
      document.body.appendChild(analyticsScriptEl);
      resolve(this.configuration);
    });
  }

  uninitialize() {
    window.removeEventListener('hashchange', this.__onHashChange__windowBound);
  }

  private __defaultConfiguration(configuration: IAnalyticsModuleConfiguration) {
    return tt.mergeWith(
      'clobber',
      {
        trackingId: ''
      },
      configuration
    ) as IAnalyticsModuleConfiguration;
  }

  private __runAnalyticsCommands() {
    this.ga =
      window.ga ||
      function (...args: any) {
        (window.ga.q = window.ga.q || []).push(args);
      };
    window.ga.l = +new Date();
    this.ga('create', `${this.configuration.trackingId}`, { siteSpeedSampleRate: 100 });
    this.ga('send', 'pageview');
    this.__onHashChange__windowBound = () => this.__onHashChange__window();
    window.addEventListener('hashchange', this.__onHashChange__windowBound);
  }

  private __onHashChange__window() {
    this.ga('set', 'page', window.location.hash);
    this.ga('send', 'pageview');
  }
}
